import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { AmountInput } from "./InputAmount";
import { useFormContext, FormProvider } from "react-hook-form";
import { common, input } from "../../../../../../i18n";

const AddOtherFugitive = () => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const stepTwoForm = useFormContext();

  return (
    <FormProvider {...stepTwoForm}>
      <Grid item xs={12} md={6}>
        <AmountInput
          label={t("Amount-of-OtherFugitiveEmission")}
          info={t("Amount-of-OtherFugitiveEmission-Description")}
          control={stepTwoForm.control}
        />
      </Grid>
    </FormProvider>
  );
};

export default AddOtherFugitive;
